module.exports = __webpack_public_path__ + "static/img/104.ce2abe6.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/104.png
// module id = 490
// module chunks = 3